import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionCreators from '../../../_store/actions/index';

import ReactTooltip from 'react-tooltip'
import styles from './PageTemplate.scss';
import { Icon, Menu } from 'components'
import Aux from '../../../_hoc/_Aux';


class PageTemplate extends Component {

	constructor(props) {
		super(props);
		this.state = { width: 0, height: 0, tooltipPosition: 'right' };
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		let tooltipPositionTmp = 'top';
		if(window.innerWidth > 600){tooltipPositionTmp = 'right'}
		this.setState({ width: window.innerWidth, height: window.innerHeight, tooltipPosition: tooltipPositionTmp });
	}
	componentDidUpdate = (prevProps, prevState, snapshot) => {
		if(this.props.printing.printing && !prevProps.printing.printing) {
			window.print();
			this.props.onPrintingStop();
		}
	}
  	render() {
		return (
			<div className={this.props.fetching.running_requests > 0 && this.props.fetching.show_globalSpinner ? styles.blurred : null}>
			    <div className={this.props.helpersBlur.appended_blurs > 0 ? [styles.wrapper, styles.blurred].join(' ') : styles.wrapper}>
			      <div className="header">{this.props.header}</div>
			      <div className="content">{this.props.children}</div>
			    </div>
		        <Menu>
		        	Menü
		        </Menu>
		        {this.props.appendComponent}
	            <ReactTooltip 
                  place={this.state.tooltipPosition} 
                  type="" 
                  effect="solid" 
                  globalEventOff="click" 
                  id='GlobalTooltip'/>
			</div>
		)
	}
}

const mapStateToProps = state => {
    return {
        helpersBlur: state.helpersBlur,
        fetching: state.fetching,
        printing: state.printing
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onPrintingStop: () => dispatch(actionCreators.printingStop()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(PageTemplate);


// WEBPACK FOOTER //
// ./src/components/templates/PageTemplate/index.js